import { render, staticRenderFns } from "./human.vue?vue&type=template&id=d4a967ce&scoped=true"
import script from "./human.vue?vue&type=script&lang=js"
export * from "./human.vue?vue&type=script&lang=js"
import style0 from "./human.vue?vue&type=style&index=0&id=d4a967ce&prod&lang=scss&scoped=true"
import style1 from "./human.vue?vue&type=style&index=1&id=d4a967ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4a967ce",
  null
  
)

export default component.exports